var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "483px",
    height: "484px",
    viewBox: "0 0 483 484",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-info-5618465") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-info-5618465",
    transform: "translate(0.000894, 0.960250)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5991061,411.44975 C164.712106,505.58275 317.309106,505.58275 411.449106,411.44975 C505.562106,317.28175 505.562106,164.69975 411.449106,70.59975 C317.301106,-23.53325 164.699106,-23.53325 70.5691061,70.59975 C-23.5288939,164.71675 -23.5288939,317.27975 70.6042621,411.44975 L70.5991061,411.44975 Z M267.039106,372.72275 L214.977106,372.72275 L214.961482,180.08275 L267.023482,180.08275 L267.039106,372.72275 Z M241.000106,85.5426845 C258.449106,85.507593 272.535106,99.62875 272.535106,117.05875 C272.535106,134.49275 258.449106,148.61375 241.000106,148.61375 C223.570106,148.61375 209.465106,134.49275 209.465106,117.06275 C209.465106,99.63275 223.570106,85.50775 241.000106,85.5426845 L241.000106,85.5426845 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteInfo);
export default __webpack_public_path__ + "static/media/whiteInfo.0a48ed2a4114aa6128ed64c87bf5651a.svg";
export { ForwardRef as ReactComponent };